var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    {
      staticClass: "personalizacaoFooter d-flex align-center",
      class: {
        "justify-space-between": !_vm.semAviso,
        "justify-end": _vm.semAviso,
        "personalizacaoFooter--embutido ma-0 px-0 pt-5 pb-3": _vm.embutido
      }
    },
    [
      !_vm.semAviso
        ? _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c("icon-svg", {
                staticClass: "mr-2",
                attrs: { name: "info", size: "18", color: "var(--text-muted)" }
              }),
              _c("span", { staticClass: "az-ds-aux ma-0" }, [
                _vm._v(
                  " As mudanças valem para todo o escritório assim que salvas. "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "d-flex align-center",
          class: _vm.embutido
            ? "flex-wrap az-gap-small"
            : "personalizacaoFooter__actions"
        },
        [
          !_vm.hideRestaurar
            ? _c(
                "BaseButton",
                {
                  attrs: {
                    underlined: "",
                    fitContent: "",
                    loading: _vm.loadingReset,
                    disabled: _vm.loadingSave || _vm.loadingReset
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("reset")
                    }
                  }
                },
                [_vm._v(" Restaurar padrão ")]
              )
            : _vm._e(),
          _c(
            "BaseButton",
            {
              attrs: { underlined: "", disabled: _vm.cancelarDesabilitado },
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "BaseButton",
            {
              attrs: {
                primary: "",
                disabled: !_vm.dirty,
                loading: _vm.loadingSave
              },
              on: {
                click: function($event) {
                  return _vm.$emit("save")
                }
              }
            },
            [_vm._v(" Salvar ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }